import React from 'react';

import {
  ExtraDetails
} from './ui';

const DataDetails = ({
  title,
  color,
  data,
  centered = false
}) => (
  <ExtraDetails.Block color={color} centered={centered}>
    <ExtraDetails.ListContainer>
      <ExtraDetails.Title>{title}</ExtraDetails.Title>
      <ExtraDetails.List>
        {
          data.map((item, index) => (
            <ExtraDetails.ListItem key={index}>{item}</ExtraDetails.ListItem>
          ))
        }
      </ExtraDetails.List>
    </ExtraDetails.ListContainer>
  </ExtraDetails.Block>
);

export default DataDetails;



// WEBPACK FOOTER //
// ./src/instructor/components/peer-feedback/components/data-details.js